/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-12-28",
    versionChannel: "nightly",
    buildDate: "2024-12-28T00:06:20.128Z",
    commitHash: "333cebeac5aa14848c9ed6933d41e3446915833d",
};
